import { ReactElement } from 'react';
import { useTranslate } from '@client/i18n/hooks';
import { STYLE_TYPE } from '@lib/components/Form/common';
import { CounterInput } from '@lib/components/Form/CounterInput';
import { ValueType } from '@lib/components/Form/Range';
import classNames from 'classnames';
import { Props } from './';
import './Quantity.scss';

export const Quantity = ({
  sku,
  quantity,
  isEditable,
  onChange,
  maxQuantity = 999,
  className,
}: Props): ReactElement => {
  const t = useTranslate();

  const handleChange = (quantity: ValueType) : void => {
    onChange(parseInt(String(quantity)));
  };

  return (
    <div className={classNames('CartProductQuantity', className)}>
      {isEditable
        ? (
          <CounterInput
            counterId={sku}
            defaultValue={quantity}
            maxValue={maxQuantity}
            onChange={handleChange}
            isValueChangeDelayed
            styleType={STYLE_TYPE.underlined}
            inputClassName="CartProductQuantity-Input"
            buttonClassName="CartProductQuantity-Button"
          />
        )
        : <div className="CartProductQuantity-NotEditable">
            <span className="CartProductQuantity-Label">{t('Quantity')}:</span>
            <span className="CartProductQuantity-Value">
              {quantity}
            </span>
          </div>
      }
    </div>
  );
};
